import React from 'react';
import { connect } from 'react-redux';

class SmallSpinner extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.preload();
  }

  preload() {
    $('body').append("<img src='/images/webreader/small-spinner.svg' hidden />")
  }

  render() {
    return (
      <div
        className={ "bg-gray-6 a-webreader-small-spinner absolute-centering " +
          (this.props.small_spinner_hidden && 'display-none')}
      >
        <div className="a-webreader-small-spinner-bg fit fit-height"></div>
        <img className="absolute-centering" src="/images/webreader/small-spinner.svg" alt="" />
      </div>
    )
  }
}

const mapStateToProps = (
  state,
  ownProps
) => {
  return {
    small_spinner_hidden: state.small_spinner_hidden
  }
};


export default connect(
  mapStateToProps
)(SmallSpinner);
